import { render } from "./switch.vue?vue&type=template&id=8387017e"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8387017e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8387017e', __exports__)) {
    api.reload('8387017e', __exports__)
  }
  
  module.hot.accept("./switch.vue?vue&type=template&id=8387017e", () => {
    api.rerender('8387017e', render)
  })

}


export default __exports__